<div class="dash-widget fade-in">
  <div class="dw-header">
    <div class="dw-title">
      <div class="dw-title__icon" style="background: var(--teal-bg)">
        <mat-icon style="color: var(--teal-dark)">security</mat-icon>
      </div>
      {{'GUI.dashboard.labels.my subscription' | translate}}
      <app-scope-chip scope="clinic"></app-scope-chip>
    </div>
    @if (hasMorningAccess && (loadingSubPayment || subPayments.length > 0)) {
    <a class="sub-viewall" [routerLink]="['/dashboard/artisan-payments']">
      {{ 'GUI.dashboard.labels.view all' | translate }}
      <mat-icon>chevron_right</mat-icon>
    </a>
    }
  </div>

  <div class="dash-widget__body">
    @if (hasMorningAccess && (loadingSubPayment || subPayments.length > 0)) {
    <div class="sub-section">
      <div class="sub-section__heading">
        {{'GUI.dashboard.labels.recent payments to artisan sonics' | translate}}
        <span class="sub-fresh" title="{{'GUI.dashboard.tooltips.refreshed' | translate}}">
          <mat-icon>schedule</mat-icon>
          {{ 'GUI.dashboard.labels.as of today' | translate }}
        </span>
      </div>
      <div class="invoice-list">
        @if (loadingSubPayment) {
        <div class="skel skel--row"></div>
        <div class="skel skel--row"></div>
        <div class="skel skel--row"></div>
        } @else { @for (payment of subPaymentsWithLabels(); track payment.documentNumber) {
        <div
          class="invoice-row invoice-row--clickable"
          (click)="openSubPayment(payment)"
          (keyup.enter)="openSubPayment(payment)"
          (keyup.space)="openSubPayment(payment)"
          tabindex="0"
          role="button"
        >
          <div class="invoice-row__av invoice-row__av--brand">AS</div>
          <div class="invoice-row__main">
            <div class="invoice-row__name">{{ payment.displayName }}</div>
            <div class="invoice-row__id">
              @if (payment.documentNumber) { #{{ payment.documentNumber }} } @if (payment.dateLabel)
              {
              <span class="invoice-row__date">{{ payment.dateLabel }}</span> }
            </div>
          </div>
          <div class="invoice-row__amount">₪{{ payment.amount }}</div>
          <span class="invoice-row__status s-paid">Paid</span>
        </div>
        } }
      </div>
    </div>

    <div class="divider divider--tight"></div>
    }

    <div class="sub-section__heading">{{'GUI.dashboard.labels.What\'s Included' | translate}}</div>
    @if (planFeaturesLoading()) {
    <div class="skel skel--row"></div>
    <div class="skel skel--row"></div>
    <div class="skel skel--row"></div>
    } @else { @if (isAdmin && clinicFeatures().length) {
    <div class="plan-tabs">
      <button
        type="button"
        class="plan-tab"
        [class.plan-tab--active]="activePlanTab() === 'clinic'"
        (click)="activePlanTab.set('clinic')"
        (keyup.enter)="activePlanTab.set('clinic')"
        (keyup.space)="activePlanTab.set('clinic')"
      >
        {{'GUI.dashboard.labels.clinic plan' | translate}}
      </button>
      <button
        type="button"
        class="plan-tab"
        [class.plan-tab--active]="activePlanTab() === 'user'"
        (click)="activePlanTab.set('user')"
        (keyup.enter)="activePlanTab.set('user')"
        (keyup.space)="activePlanTab.set('user')"
      >
        {{'GUI.dashboard.labels.your access' | translate}}
      </button>
    </div>
    } @if (activeGroups().length) { @for (group of activeGroups(); track group.category) {
    <div class="plan-group-head">{{ 'GUI.dashboard.labels.' + group.label | translate }}</div>
    <div class="plan-features">
      @for (feature of group.features; track feature.key) {
      <div class="plan-feat" [class.plan-feat--off]="!feature.included">
        <mat-icon [class.plan-feat__icon--included]="feature.included"
          >{{ feature.included ? 'check' : 'close' }}</mat-icon
        >
        {{ feature.label }}
      </div>
      }
    </div>
    } } @else {
    <p class="empty-state">{{'GUI.dashboard.labels.No plan data available' | translate}}</p>
    } } @if (suggestedFeatures().length) {
    <div class="divider divider--tight"></div>
    <div class="sub-section__heading">{{'GUI.dashboard.labels.Expand your plan' | translate}}</div>
    <div class="plan-suggest">
      @for (feature of suggestedFeatures(); track feature.key) {
      <div class="plan-suggest__row">
        <mat-icon class="plan-suggest__icon">add_circle_outline</mat-icon>
        <div class="plan-suggest__name">{{ feature.label }}</div>
        @if (feature.price !== null) {
        <div class="plan-suggest__price">₪{{ feature.price }}</div>
        }
        <!-- Everyone sees the upsell, but only doctors/admins can raise the request. -->
        @if (canRequest) {
        <button
          type="button"
          class="plan-suggest__btn"
          [class.plan-suggest__btn--done]="requestState()[feature.key] === 'done'"
          [disabled]="!!requestState()[feature.key]"
          (click)="requestFeature(feature)"
        >
          @if (requestState()[feature.key] === 'done') {
          <mat-icon>check</mat-icon> {{'GUI.dashboard.buttons.Requested' | translate}} } @else if
          (requestState()[feature.key] === 'sending') { Sending… } @else {
          {{'GUI.dashboard.buttons.Request' | translate}} }
        </button>
        }
      </div>
      }
    </div>
    }
  </div>
</div>

<app-embed-modal
  [url]="subPaymentModalUrl()"
  title="Subscription Invoice"
  (closed)="closeSubPaymentModal()"
></app-embed-modal>
